module.exports = __webpack_public_path__ + "assets/img/year-title-bg3.8f5c4b92.png";